import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { type ComboboxOption } from "@/components/Combobox/types";
import { graphql, type ResultOf } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";

type FeedyardId = string;

type Props = {
  id?: string;
  selected: Array<FeedyardId>;
  onSelect: (values: Array<FeedyardId>) => void;
  className?: string;
};

export type FeedyardsData = ResultOf<typeof supplyChainLotFeedyardsQuery>;

export function FeedyardPicker({ id, selected, onSelect, className }: Props) {
  const { activeBusinessUnitId } = useActiveBusinessUnit();
  const { data, loading } = useQuery(supplyChainLotFeedyardsQuery, {
    variables: { businessUnit: activeBusinessUnitId },
  });

  const options: Array<ComboboxOption> = getFeedyardsOptions(data);

  return (
    <Combobox
      id={id}
      type="multi"
      name="feedyards"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      className={className}
    />
  );
}

export const getFeedyardsOptions = (data: FeedyardsData | undefined) => {
  const options = removeNothings(data?.supplyChainLotFeedyards?.edges || []).map((edge) => {
    return {
      label: edge.node.name,
      value: edge.node.id,
    };
  });

  return options;
};

export const supplyChainLotFeedyardsQuery = graphql(`
  query SupplyChainLotFeedyards($businessUnit: ID) {
    supplyChainLotFeedyards(businessUnit: $businessUnit) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`);
